// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1tj21","select":"Header_select__12zyh","clinic":"Header_clinic__14ZmW"};